import * as subjects from "./constants/subjects";
import * as paths from "./constants/paths";

// Germany - DiscoveryPlus
import germany_dplus_form from "views/discoveryplus/germany/form";
import germany_dplus_interstitial_android from "views/discoveryplus/germany/interstitial_android";
import germany_dplus_interstitial_ios from "views/discoveryplus/germany/interstitial_ios";
import germany_dplus_confirmation from "views/discoveryplus/germany/confirmation";

// Germany - Eurosport
import germany_eurosport_form from "views/eurosport/germany/form";
import germany_eurosport_interstitial_android from "views/eurosport/germany/interstitial_android";
import germany_eurosport_interstitial_ios from "views/eurosport/germany/interstitial_ios";
import germany_eurosport_confirmation from "views/eurosport/germany/confirmation";

// Germany - Eurosport Player
import germany_eurosportPlayer_form from "views/eurosportPlayer/germany/form";
import germany_eurosportPlayer_interstitial_android from "views/eurosportPlayer/germany/interstitial_android";
import germany_eurosportPlayer_interstitial_ios from "views/eurosportPlayer/germany/interstitial_ios";
import germany_eurosportPlayer_confirmation from "views/eurosportPlayer/germany/confirmation";

// Germany - GolfTV
import germany_golftv_form from "views/golftv/germany/form";
import germany_golftv_interstitial_android from "views/golftv/germany/interstitial_android";
import germany_golftv_interstitial_ios from "views/golftv/germany/interstitial_ios";
import germany_golftv_confirmation from "views/golftv/germany/confirmation";

// Germany - GCN
import germany_gcn_form from "views/gcn/germany/form";
import germany_gcn_interstitial_android from "views/gcn/germany/interstitial_android";
import germany_gcn_interstitial_ios from "views/gcn/germany/interstitial_ios";
import germany_gcn_confirmation from "views/gcn/germany/confirmation";

// Germany - Max
import germany_max_form from "views/max/germany/form";
import germany_max_interstitial_android from "views/max/germany/interstitial_android";
import germany_max_interstitial_ios from "views/max/germany/interstitial_ios";
import germany_max_confirmation from "views/max/germany/confirmation";

// France - DiscoveryPlus
import france_dplus_form from "views/discoveryplus/france/form";
import france_dplus_interstitial_android from "views/discoveryplus/france/interstitial_android";
import france_dplus_interstitial_ios from "views/discoveryplus/france/interstitial_ios";
import france_dplus_confirmation from "views/discoveryplus/france/confirmation";

// France - Eurosport
import france_eurosport_form from "views/eurosport/france/form";
import france_eurosport_interstitial_android from "views/eurosport/france/interstitial_android";
import france_eurosport_interstitial_ios from "views/eurosport/france/interstitial_ios";
import france_eurosport_confirmation from "views/eurosport/france/confirmation";

// France - Eurosport Player
import france_eurosportPlayer_form from "views/eurosportPlayer/france/form";
import france_eurosportPlayer_interstitial_android from "views/eurosportPlayer/france/interstitial_android";
import france_eurosportPlayer_interstitial_ios from "views/eurosportPlayer/france/interstitial_ios";
import france_eurosportPlayer_confirmation from "views/eurosportPlayer/france/confirmation";

// France - GolfTV
import france_golftv_form from "views/golftv/france/form";
import france_golftv_interstitial_android from "views/golftv/france/interstitial_android";
import france_golftv_interstitial_ios from "views/golftv/france/interstitial_ios";
import france_golftv_confirmation from "views/golftv/france/confirmation";

// France - GCN
import france_gcn_form from "views/gcn/france/form";
import france_gcn_interstitial_android from "views/gcn/france/interstitial_android";
import france_gcn_interstitial_ios from "views/gcn/france/interstitial_ios";
import france_gcn_confirmation from "views/gcn/france/confirmation";

// France - Max
import france_max_form from "views/max/france/form";
import france_max_interstitial_android from "views/max/france/interstitial_android";
import france_max_interstitial_ios from "views/max/france/interstitial_ios";
import france_max_confirmation from "views/max/france/confirmation";

import canada_dplus_form from "views/discoveryplus/canada/form";
import canada_dplus_interstitial_android from "views/discoveryplus/canada/interstitial_android";
import canada_dplus_interstitial_ios from "views/discoveryplus/canada/interstitial_ios";
import canada_dplus_confirmation from "views/discoveryplus/canada/confirmation";
import { en } from "constants/label";

const countries = {
  [paths.subDomainGermany]: {
    form: {
      [paths.brand_eurosport]: germany_eurosport_form,
      [paths.brand_dplus]: germany_dplus_form,
      [paths.brand_eurosportPlayer]: germany_eurosportPlayer_form,
      [paths.brand_golftv]: germany_golftv_form,
      [paths.brand_gcn]: germany_gcn_form,
      [paths.brand_max]: germany_max_form
    },
    interstitial_android: {
      [paths.brand_eurosport]: germany_eurosport_interstitial_android,
      [paths.brand_dplus]: germany_dplus_interstitial_android,
      [paths.brand_eurosportPlayer]: germany_eurosportPlayer_interstitial_android,
      [paths.brand_golftv]: germany_golftv_interstitial_android,
      [paths.brand_gcn]: germany_gcn_interstitial_android,
      [paths.brand_max]: germany_max_interstitial_android
    },
    interstitial_ios: {
      [paths.brand_eurosport]: germany_eurosport_interstitial_ios,
      [paths.brand_dplus]: germany_dplus_interstitial_ios,
      [paths.brand_eurosportPlayer]: germany_eurosportPlayer_interstitial_ios,
      [paths.brand_golftv]: germany_golftv_interstitial_ios,
      [paths.brand_gcn]: germany_gcn_interstitial_ios,
      [paths.brand_max]: germany_max_interstitial_ios
    },
    confirmation: {
      [paths.brand_eurosport]: germany_eurosport_confirmation,
      [paths.brand_dplus]: germany_dplus_confirmation,
      [paths.brand_eurosportPlayer]: germany_eurosportPlayer_confirmation,
      [paths.brand_golftv]: germany_golftv_confirmation,
      [paths.brand_gcn]: germany_gcn_confirmation,
      [paths.brand_max]: germany_max_confirmation
    }
  },
  [paths.subDomainFrance]: {
    form: {
      [paths.brand_eurosport]: france_eurosport_form,
      [paths.brand_dplus]: france_dplus_form,
      [paths.brand_eurosportPlayer]: france_eurosportPlayer_form,
      [paths.brand_golftv]: france_golftv_form,
      [paths.brand_gcn]: france_gcn_form,
      [paths.brand_max]: france_max_form
    },
    interstitial_android: {
      [paths.brand_eurosport]: france_eurosport_interstitial_android,
      [paths.brand_dplus]: france_dplus_interstitial_android,
      [paths.brand_eurosportPlayer]: france_eurosportPlayer_interstitial_android,
      [paths.brand_golftv]: france_golftv_interstitial_android,
      [paths.brand_gcn]: france_gcn_interstitial_android,
      [paths.brand_max]: france_max_interstitial_android
    },
    interstitial_ios: {
      [paths.brand_eurosport]: france_eurosport_interstitial_ios,
      [paths.brand_dplus]: france_dplus_interstitial_ios,
      [paths.brand_eurosportPlayer]: france_eurosportPlayer_interstitial_ios,
      [paths.brand_golftv]: france_golftv_interstitial_ios,
      [paths.brand_gcn]: france_gcn_interstitial_ios,
      [paths.brand_max]: france_max_interstitial_ios
    },
    confirmation: {
      [paths.brand_eurosport]: france_eurosport_confirmation,
      [paths.brand_dplus]: france_dplus_confirmation,
      [paths.brand_eurosportPlayer]: france_eurosportPlayer_confirmation,
      [paths.brand_golftv]: france_golftv_confirmation,
      [paths.brand_gcn]: france_gcn_confirmation,
      [paths.brand_max]: france_max_confirmation
    }
  },
  [paths.subDomainCanada]: {
    form: {
      [paths.brand_eurosport]: canada_dplus_form,
      [paths.brand_dplus]: canada_dplus_form,
      [paths.brand_eurosportPlayer]: canada_dplus_form,
      [paths.brand_golftv]: canada_dplus_form,
      [paths.brand_gcn]: canada_dplus_form
    },
    interstitial_android: {
      [paths.brand_eurosport]: canada_dplus_interstitial_android,
      [paths.brand_dplus]: canada_dplus_interstitial_android,
      [paths.brand_eurosportPlayer]: canada_dplus_interstitial_android,
      [paths.brand_golftv]: canada_dplus_interstitial_android,
      [paths.brand_gcn]: canada_dplus_interstitial_android
    },
    interstitial_ios: {
      [paths.brand_eurosport]: canada_dplus_interstitial_ios,
      [paths.brand_dplus]: canada_dplus_interstitial_ios,
      [paths.brand_eurosportPlayer]: canada_dplus_interstitial_ios,
      [paths.brand_golftv]: canada_dplus_interstitial_ios,
      [paths.brand_gcn]: canada_dplus_interstitial_ios
    },
    confirmation: {
      [paths.brand_eurosport]: canada_dplus_confirmation,
      [paths.brand_dplus]: canada_dplus_confirmation,
      [paths.brand_eurosportPlayer]: canada_dplus_confirmation,
      [paths.brand_golftv]: canada_dplus_confirmation,
      [paths.brand_gcn]: canada_dplus_confirmation
    }
  }
}

export const eurosportPlayerRoutes = (country) => [
  {
    id: subjects.EUROSPORT_PLAYER_ANDROIDAPP_INTERSTITIAL,
    paths: paths.eurosportPlayer_android_app_interstitial(country),
    component: countries[country].interstitial_android[paths.brand_eurosportPlayer],
  },
  {
    id: subjects.EUROSPORT_PLAYER_IOSAPP_INTERSTITIAL,
    paths: paths.eurosportPlayer_ios_app_interstitial(country),
    component: countries[country].interstitial_ios[paths.brand_eurosportPlayer],
  },
  {
    id: subjects.EUROSPORT_PLAYER_FORM,
    paths: [paths.eurosportPlayer_website_form(country), paths.eurosportPlayer_ios_app_form(country), paths.eurosportPlayer_android_app_form(country), paths.eurosportPlayer_connected_tv_form(country)],
    component: countries[country].form[paths.brand_eurosportPlayer],

  },
  {
    id: subjects.EUROSPORT_PLAYER_CONFIRMATION,
    paths: [paths.eurosportPlayer_website_confirmation(country), paths.eurosportPlayer_ios_app_confirmation(country), paths.eurosportPlayer_android_app_confirmation(country), paths.eurosportPlayer_connected_tv_confirmation(country)],
    component: countries[country].confirmation[paths.brand_eurosportPlayer],
  },
]

export const dplusRoutes = (country) => {
  const langSuffix = `/:lang(${en})?`;

  return [
    {
      id: subjects.DPLUS_ANDROIDAPP_INTERSTITIAL,
      paths: [
        paths.dplus_android_app_interstitial(country),
        paths.dplus_android_app_interstitial(country) + langSuffix,
      ],
      component: countries[country].interstitial_android[paths.brand_dplus],
    },
    {
      id: subjects.DPLUS_IOSAPP_INTERSTITIAL,
      paths: [
        paths.dplus_ios_app_interstitial(country),
        paths.dplus_ios_app_interstitial(country) + langSuffix,
      ],
      component: countries[country].interstitial_ios[paths.brand_dplus],
    },
    {
      id: subjects.DPLUS_FORM,
      paths: [
        paths.dplus_website_form(country),
        paths.dplus_website_form(country) + langSuffix,

        paths.dplus_ios_app_form(country),
        paths.dplus_ios_app_form(country) + langSuffix,

        paths.dplus_android_app_form(country),
        paths.dplus_android_app_form(country) + langSuffix,

        paths.dplus_connected_tv_form(country),
        paths.dplus_connected_tv_form(country) + langSuffix,
      ],
      component: countries[country].form[paths.brand_dplus],
    },
    {
      id: subjects.DPLUS_CONFIRMATION,
      paths: [
        paths.dplus_website_confirmation(country),
        paths.dplus_website_confirmation(country) + langSuffix,

        paths.dplus_ios_app_confirmation(country),
        paths.dplus_ios_app_confirmation(country) + langSuffix,

        paths.dplus_android_app_confirmation(country),
        paths.dplus_android_app_confirmation(country) + langSuffix,

        paths.dplus_connected_tv_confirmation(country),
        paths.dplus_connected_tv_confirmation(country) + langSuffix,
      ],
      component: countries[country].confirmation[paths.brand_dplus],
    },
  ];
};


export const gtvRoutes = (country) => [
  {
    id: subjects.GOLFTV_ANDROIDAPP_INTERSTITIAL,
    paths: paths.golftv_android_app_interstitial(country),
    component: countries[country].interstitial_android[paths.brand_golftv],
  },
  {
    id: subjects.GOLFTV_IOSAPP_INTERSTITIAL,
    paths: paths.golftv_ios_app_interstitial(country),
    component: countries[country].interstitial_ios[paths.brand_golftv],
  },
  {
    id: subjects.GOLFTV_FORM,
    paths: [paths.golftv_website_form(country), paths.golftv_ios_app_form(country), paths.golftv_android_app_form(country), paths.golftv_connected_tv_form(country)],
    component: countries[country].form[paths.brand_golftv],
  },
  {
    id: subjects.GOLFTV_CONFIRMATION,
    paths: [paths.golftv_website_confirmation(country), paths.golftv_ios_app_confirmation(country), paths.golftv_android_app_confirmation(country), paths.golftv_connected_tv_confirmation(country)],
    component: countries[country].confirmation[paths.brand_golftv],
  },
]

export const eurosportRoutes = (country) => [
  {
    id: subjects.EUROSPORT_ANDROIDAPP_INTERSTITIAL,
    paths: paths.eurosport_android_app_interstitial(country),
    component: countries[country].interstitial_android[paths.brand_eurosport],
  },
  {
    id: subjects.EUROSPORT_IOSAPP_INTERSTITIAL,
    paths: paths.eurosport_ios_app_interstitial(country),
    component: countries[country].interstitial_ios[paths.brand_eurosport],
  },
  {
    id: subjects.EUROSPORT_FORM,
    paths: [paths.eurosport_website_form(country), paths.eurosport_ios_app_form(country), paths.eurosport_android_app_form(country), paths.eurosport_connected_tv_form(country)],
    component: countries[country].form[paths.brand_eurosport],
  },
  {
    id: subjects.EUROSPORT_CONFIRMATION,
    paths: [paths.eurosport_website_confirmation(country), paths.eurosport_ios_app_confirmation(country), paths.eurosport_android_app_confirmation(country), paths.eurosport_connected_tv_confirmation(country)],
    component: countries[country].confirmation[paths.brand_eurosport],
  },
]

export const maxRoutes = (country) => {
  const langSuffix = `/:lang(${en})?`;

  return [
    {
      id: subjects.MAX_ANDROIDAPP_INTERSTITIAL,
      paths: [
        paths.max_android_app_interstitial(country),
        paths.max_android_app_interstitial(country) + langSuffix,
      ],
      component: countries[country].interstitial_android[paths.brand_max],
    },
    {
      id: subjects.MAX_IOSAPP_INTERSTITIAL,
      paths: [
        paths.max_ios_app_interstitial(country),
        paths.max_ios_app_interstitial(country) + langSuffix,
      ],
      component: countries[country].interstitial_ios[paths.brand_max],
    },
    {
      id: subjects.MAX_FORM,
      paths: [
        paths.max_website_form(country),
        paths.max_website_form(country) + langSuffix,

        paths.max_ios_app_form(country),
        paths.max_ios_app_form(country) + langSuffix,

        paths.max_android_app_form(country),
        paths.max_android_app_form(country) + langSuffix,

        paths.max_connected_tv_form(country),
        paths.max_connected_tv_form(country) + langSuffix,
      ],
      component: countries[country].form[paths.brand_max],
    },
    {
      id: subjects.MAX_CONFIRMATION,
      paths: [
        paths.max_website_confirmation(country),
        paths.max_website_confirmation(country) + langSuffix,

        paths.max_ios_app_confirmation(country),
        paths.max_ios_app_confirmation(country) + langSuffix,

        paths.max_android_app_confirmation(country),
        paths.max_android_app_confirmation(country) + langSuffix,

        paths.max_connected_tv_confirmation(country),
        paths.max_connected_tv_confirmation(country) + langSuffix,
      ],
      component: countries[country].confirmation[paths.brand_max],
    },
  ];
};


export const gcnRoutes = (country) => [
  {
    id: subjects.GCN_ANDROIDAPP_INTERSTITIAL,
    paths: paths.gcn_android_app_interstitial(country),
    component: countries[country].interstitial_android[paths.brand_gcn],
  },
  {
    id: subjects.GCN_IOSAPP_INTERSTITIAL,
    paths: paths.gcn_ios_app_interstitial(country),
    component: countries[country].interstitial_ios[paths.brand_gcn],
  },
  {
    id: subjects.GCN_FORM,
    paths: [paths.gcn_website_form(country), paths.gcn_ios_app_form(country), paths.gcn_android_app_form(country), paths.gcn_connected_tv_form(country)],
    component: countries[country].form[paths.brand_gcn],
  },
  {
    id: subjects.GCN_CONFIRMATION,
    paths: [paths.gcn_website_confirmation(country), paths.gcn_ios_app_confirmation(country), paths.gcn_android_app_confirmation(country), paths.gcn_connected_tv_confirmation(country)],
    component: countries[country].confirmation[paths.brand_gcn],
  },
]

